<template>

  <div class="container-fluid">


    <hr/>
    <h5>گزارش کار بر اساس برنامه ریزی</h5>

    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class=""
            class="mt-3"
    >
      <!--------first tab------->
      <b-tab title="گزارش کل برنامه ها" active>
        <div v-if="isLoading">
          <Preloader/>
        </div>
        <div>
          <div class="row my-2 text-center" v-if="nodata">
            <div class="col-12 mt-3">
              <h5>برنامه ای ثبت نشده است</h5>

            </div>
          </div>
          <div class="row my-2" v-else>
            <div class="col-12 mt-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col" class="text-center">نام محصول</th>
                  <th scope="col" class="text-center">کد برنامه</th>
                  <th scope="col" class="text-center">تاریخ برنامه</th>
                  <th scope="col" class="text-center">تعداد کل</th>
                  <th scope="col" class="text-center">کامل شده</th>
                  <th scope="col" class="text-center">در انتظار</th>
                  <th scope="col" class="text-center">متوقف</th>
                  <!--<th scope="col" class="text-center">درحال تولید</th>-->
                  <!--<th scope="col" class="text-center">تولید شده</th>-->
                  <th scope="col" class="text-center">تایید شده</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in reportTotalProgram">
                  <!--<th scope="row" class="text-center">{{item.id}}</th>-->
                  <td class="text-center">{{item.productName}}</td>
                  <td class="text-center">{{item.programCode}}</td>
                  <td class="text-center">{{item.programfDate}}</td>
                  <td class="text-center">{{item.programCount}}</td>
                  <td class="text-center" colspan="6" v-if="item.sendToWork === false">دستور تولید داده نشده است</td>
                  <td class="text-center" v-if="item.sendToWork === true">{{item.completedCount}}</td>
                  <td class="text-center" v-if="item.sendToWork === true">{{item.inQueueStatusCount}}</td>
                  <td class="text-center" v-if="item.sendToWork === true">{{item.problemStatusCount}}</td>
                  <!--<td class="text-center" v-if="item.sendToWork === true">{{item.doingStatusCount}}</td>-->
                  <!--<td class="text-center" v-if="item.sendToWork === true">{{item.doneStatusCount}}</td>-->
                  <td class="text-center" v-if="item.sendToWork === true">{{item.confirmStatusCount}}</td>
                  <!--<td class="text-center"> <button @click="showProgramDetail(item.productId)" class="btn iconed btn-success"><i-->
                  <!--class="icon-file-document-box-multiple"></i><span></span></button></td>-->
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </b-tab>
      <!--------first tab------->
      <b-tab title="گزارش کار کارگاه ها به تفکیک برنامه">

        <h5>گزارش کار کارگاه ها به تفکیک برنامه ریزی</h5>

        <div class="col-11">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کد برنامه را انتخاب کنید</span>
              </div>
            </div>
            <vs-select
              ref="selectedProgram"
              :isHeader="true"
              :data="programCodes"
              :selectedVal="programCodes.programId"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="programSelect"
              aria-placeholder="لطفا برنامه را انتخاب کنید"
            ></vs-select>
            <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
          </div>
        </div>


        <div class="row my-2 text-center" v-if="nodata1">
          <div class="col-12 mt-3">
            <h5>برنامه ای ثبت نشده است</h5>

          </div>
        </div>
        <div class="row my-2" v-else>
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">کد برنامه</th>
                <th scope="col" class="text-center">تاریخ برنامه</th>
                <th scope="col" class="text-center">تعداد</th>
                <th scope="col" class="text-center">تولیده شده</th>
                <th scope="col" class="text-center">انحراف</th>

              </tr>
              </thead>
              <tbody>
              <tr>
                <!--<th scope="row" class="text-center">{{item.id}}</th>-->
                <td class="text-center">{{reportProgram.productName}}</td>
                <td class="text-center">{{reportProgram.programCode}}</td>
                <td class="text-center">{{reportProgram.programfDate}}</td>
                <td class="text-center">{{reportProgram.totalCount}}</td>
                <td class="text-center">{{reportProgram.completedCount}}</td>
                <td class="text-center">{{reportProgram.remain < 0 ? "(" + reportProgram.remain*-1 +"-)":reportProgram.remain }}</td>

              </tr>
              </tbody>
            </table>
          </div>

          <div class="row my-2 text-center" v-if="nodata2">
            <div class="col-12 mt-3">
              <h5 class="text-center">دستور تولید داده نشده است</h5>

            </div>
          </div>
          <div class="col-12 mt-3" v-else>
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">کد کار</th>
                <!--<th scope="col" class="text-center">مشاهده جرئیات</th>-->
                <th scope="col" class="text-center">نام کارگاه</th>
                <th scope="col" class="text-center">نام اپراتور</th>
                <th scope="col" class="text-center">تعداد</th>
                <th scope="col" class="text-center">راندمان</th>
                <th scope="col" class="text-center">وضعیت</th>
                <th scope="col" class="text-center">زمان انجام کار(ساعت)</th>

              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in reportProgram.workReportCompanyLists">
                <!--<th scope="row" class="text-center">{{item.id}}</th>-->
                <td class="text-center">{{item.workCode}}</td>
                <!--<td class="text-center">-->
                <!--<button class="btn btn-success mx-2 " @click="btnClicked(item)"><i class="icon-content-duplicate"></i>-->
                <!--</button>-->
                <!--</td>-->
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.user}}</td>
                <td class="text-center">{{item.workCount}}</td>
                <td class="text-center">{{item.randeman}}</td>
                <td class="text-center">{{item.statusName}}</td>
                <td class="text-center">{{item.hoursInStatus}}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </b-tab>
    </b-tabs>

    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="detail-modal"
      id="detailModal"
      size="xl"
      title="جزئیات کار"
      ok-title="بستن"
      ok-only
      @hide="resetFlowchartFlag"
    >

      <div class="flowchart">

        <div class="row">
          <div class="col-2 mt-3">
            <div class="col mt-1">
              <span class="badge badge-warning" style="background-color: #FF8F00; font-size: 10px;">درصف انتظار</span>
            </div>
            <!--<div class="col mt-1">-->
            <!--<span class="badge badge-success" style="background-color: #9E9D24; color: black; font-size: 10px">درحال انجام</span>-->
            <!--</div>-->
            <!--<div class="col mt-1">-->
            <!--<span class="badge badge-success" style="background-color: #2E7D32; font-size: 10px">تکمیل شده</span>-->
            <!--</div>-->
            <div class="col mt-1">
              <span class="badge badge-info text-white"
                    style="background-color: #0277BD; font-size: 10px;">تایید شده</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-primary" style="background-color: #deddff; font-size: 10px">غیرفعال</span>
            </div>
            <div class="col mt-1">
              <span class="badge badge-danger" style="background-color: #c62828; font-size: 10px">مشکل</span>
            </div>
          </div>
          <div class="col-10 d-flex align-items-center">
            <work-flowchart ref="flowchart" :works="innerWorkDetails"></work-flowchart>
          </div>
        </div>
      </div>
    </b-modal>
    <!-------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import VsSelect from "../../_framework/VsSelect";
  import WorkChart from "../../components/WorkChart.vue";
  import WorkStatus from "../../components/WorkStatus.vue";
  import WorkFlowchart from "../../components/WorkFlowchart.vue";
  import flowchart from "../../components/WorkFlowchart.vue"
  import {bus} from '../../main';
  import EventBus from "../../bus.js";
  import Moment from 'moment-jalali';

  export default {
    name: "workreport-total-program",
    created: () => {
    },
    components: {
      VsTable,
      Products,
      VsSelect,
      WorkChart,
      WorkStatus,
      WorkFlowchart,
      Moment,
    },
    data() {
      return {
        show: true,
        nodata: true,
        nodata1: true,
        nodata2: false,
        access: {},
        product: {},
        productQuantity: {},
        productName: "",
        unitName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],
        reportTotalProgram: [],
        reportProgram: [],
        programs: [],
        programCodes: [],
        innerWorkDetails: {},
        workDetail: [],
        isLoading: false,

      };
    },
    beforeMount() {
      this.getReportTotalProgram();
      // this.getReportProgram();
      this.getProgram();

    },
    methods: {

      getReportTotalProgram() {
        this.isLoading = true;
        new BaseService('WorksReports', '/GetWorkReportTotalProgram/').getList().then((response) => {
          // console.log(response.data);
          this.isLoading = false;
          if (response.data === null || response.data === "") {
            this.nodata = true;
          } else {
            this.reportTotalProgram = response.data;

            if (this.reportTotalProgram.length === 0) {
              this.nodata = true;
            } else {
              this.nodata = false;
              for (var i of this.reportTotalProgram) {
                i.programfDate = Moment(i.programDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");
              }
            }
          }
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      getReportProgram(id, productId) {
        new BaseService('WorksReports', '/GetWorkReportProgram/' + id + '/' + productId).getList().then((response) => {
          // console.log(response.data);
          this.nodata1 = false;
          this.nodata2 = false;
          if (response.data === null || response.data === "") {
            this.nodata1 = true;
          } else {
            this.reportProgram = response.data;
            if (this.reportProgram.length === 0) {
              this.nodata1 = true;
            } else {
              this.nodata1 = false;
              // console.log(this.reportProgram.workReportCompanyLists.length)
              // console.log(this.reportProgram.workReportCompanyLists)
              if (this.reportProgram.sendToWork === false) {
                this.nodata2 = true;
              }
              this.reportProgram.remain = this.reportProgram.completedCount - this.reportProgram.totalCount ;
              this.reportProgram.programfDate = Moment(this.reportProgram.programDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");
              for (let item of this.reportProgram.workReportCompanyLists) {

                switch (item.status) {
                  case 0 :
                    item.statusName = "در انتظار";
                    break;
                  case 1 :
                    item.statusName = "متوقف";
                    break;
                  case 2 :
                    item.statusName = "در حال تولید";
                    break;
                  case 3 :
                    item.statusName = "تولید شده";
                    break;
                  case 4 :
                    item.statusName = "تائید شده";
                    break;
                }

              }
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },

      getProgram() {
        new BaseService('Planning', '/GetAllProgramCode').getList().then((response) => {
          this.programCodes = response.data;
          if (this.programCodes.length > 0) {
            for (let i = 0; i < this.programCodes.length; i++) {
              this.programCodes[i].name = "برنامه کد " + this.programCodes[i].programCode + " کالای " + this.programCodes[i].productName + " تعداد " + this.programCodes[i].count + " باقیمانده " + (this.programCodes[i].count - this.programCodes[i].completed);
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      programSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.getReportProgram(data.programId, data.productId);

      },
      btnClicked(item) {
        // console.log("clike")


        this.$refs['detail-modal'].show()
        this.getOrderDetail(item.workId);
      },
      getOrderDetail(workId) {
        // console.log(workId)
        new BaseService('WorksReports', '/GetOrderDetailWorks/' + workId).getList().then((response) => {
          // setTimeout(() => {
          //   console.log("sss")
          //   // if (this.$refs.flowchart !== undefined) {
          //   // console.log("ssssdssdds")
          this.$refs.flowchart.getFlowchartDetail(response.data);
          //   // }
          // }, 10)
          //   console.log(response.data)
          this.innerWorkDetails = response.data;
          this.workDetail = this.innerWorkDetails.works;
        }).catch((error) => {
          console.log(error)
        })
      },
      resetFlowchartFlag() {
        this.$refs['detail-modal'].hide();
      },

    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
